export const CivFaculty = [


    {
        "designation": "Professor",
        "Name": "Prof. K. Mallikarjuna Rao",
        "Phone": "(+91)-9491672378",
        "Email": "	kmr_svuce@yahoo.com",
        "Details": "https://vidwan.inflibnet.ac.in//profile/422504"
    },
    {
        "designation": "Professor",
        "Name": "Prof. I.V. Ramana Reddy",
        "Phone": "(+91)-9849678039",
        "Email": "svshaar4@yahoo.co.in",
        "Details": "https://vidwan.inflibnet.ac.in/profile/618647"
    },
    {
        "designation": "Professor",
        "Name": "Prof. M. Srimurali",
        "Phone": "(+91)-9848264604",
        "Email": "	msrimurali@yahoo.co.in",
        "Details": "https://vidwan.inflibnet.ac.in/profile/620350"
    },
    {
        "designation": "Professor",
        "Name": "Prof. D.V.Satyanarayana Moorthy",
        "Phone": "(+91)-8500049875",
        "Email": "dvsmsvu@gmail.com",
        "Details": "https://vidwan.inflibnet.ac.in/profile/619445"
    },
    {
        "designation": "Professor",
        "Name": "Prof. Ch. Sudha Rani",
        "Phone": "(+91)-9490017047",
        "Email": "sudhajawahar@gmail.com",
        "Details": "https://vidwan.inflibnet.ac.in/profile/617123"
    },
    {
        "designation": "Professor",
        "Name": "Prof. D.V. Prasada Rao",
        "Phone": "(+91)-9704387674",
        "Email": "dvprsvu@gmail.com",
        "Details": "https://vidwan.inflibnet.ac.in//profile/615721"
    },
    {
        "designation": "Professor",
        "Name": "Dr. B. Madhusudhana Reddy",
        "Phone": "	(+91)-9492657516",
        "Email": "	srinimasa@gmail.com",
        "Details": "https://vidwan.inflibnet.ac.in//profile/591869"
    },
    {
        "designation": "Associate Professor",
        "Name": "Dr. N. Munilakshmi",
        "Phone": "(+91)-9866437937",
        "Email": "nml.svuce@gmail.com",
        "Details": "https://vidwan.inflibnet.ac.in/profile/591879"
    },
    {
        "designation": "Associate Professor",
        "Name": "Dr. S. Aruna Jyothy",
        "Phone": "(+91)-9885703524",
        "Email": "aruna_jyothy@yahoo.co.in",
        "Details": "https://vidwan.inflibnet.ac.in/profile/469788"
    },

    {
        "designation": "Associate Professor",
        "Name": "Dr. T. Hemalatha",
        "Phone": "	(+91)-9640862212",
        "Email": "t_hemalatha@yahoo.co.in",
        "Details": "https://vidwan.inflibnet.ac.in//profile/591559"
    },
    {
        "designation": "Assistant Professor",
        "Name": "Sri D. Sreehari Rao",
        "Phone": "	(+91)-9959776569",
        "Email": "rao1777@gmail.com",
        "Details": "https://vidwan.inflibnet.ac.in/profile/620830"
    },
    {
        "designation": "Academic Consultant",
        "Name": "Mr. M. RUBEN PRADEEP",
        "Phone": "(+91)-7893430354",
        "Email": "ruby.albert146@gmail.com",
        "Details": "https://vidwan.inflibnet.ac.in/profile/591293"
    }, {
        "designation": "Academic Consultant",
        "Name": "N. Rushwanth Chowdary",
        "Phone": "NA",
        "Email": "NA",
        "Details":"https://vidwan.inflibnet.ac.in/profile/591303"
    },
    {
        "designation": "Academic Consultant",
        "Name": "SK. MOHISINA TAYYIBA",
        "Phone": "NA",
        "Email": "NA",
        "Details":"https://vidwan.inflibnet.ac.in/profile/591256"
    },
    {
        "designation": "Academic Consultant",
        "Name": "Dr. G. Shanmukha Srinivas",
        "Phone": "(+91)-9912577677",
        "Email": "gssmtech@gmail.com",
        "Details": "/CivFiles/CIV_Dr. G. SHANMUKHA SRINIVAS.pdf"
    }, {
        "designation": "Academic Consultant",
        "Name": "Dr.S. VIJAYA BHASKAR",
        "Phone": "9440477751",
        "Email": "NA",
        "Details": "https://vidwan.inflibnet.ac.in/profile/591230"
    }, {
        "designation": "Academic Consultant",
        "Name": "M. GURU PRASAD",
        "Phone": "NA",
        "Email": "NA",
        "Details": "https://vidwan.inflibnet.ac.in/profile/620984"
    },
    {
        "designation": "Academic Consultant",
        "Name": "B RAVISANKAR REDDY",
        "Phone": "NA",
        "Email": "NA",
        "Details": "https://vidwan.inflibnet.ac.in/profile/591244"
    },
    









]
